import React from 'react';

import {ForgotPassword} from 'presentation/pages';

export const MakeForgotPasswordPage: React.FC = () => <ForgotPassword />;
